import type { RouteParamsGeneric } from '#vue-router'

import { useCommonStore } from '@stores/common'
import { useDisciplineStore } from '@stores/discipline'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface AssessmentResultPayload {
  params:   RouteParamsGeneric
}

interface AssessmentResultApiOptions {
  onStart?: () => void
  onSuccess?: (disciplineInfo: any) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useAssessmentResultApi = async (payload: AssessmentResultPayload, options?: AssessmentResultApiOptions): Promise<any> => {
  const { $axios } = useNuxtApp()

  const commonStore = useCommonStore()
  const disciplineStore = useDisciplineStore()

  const disciplineId = disciplineStore.getDisciplineInfo?.id || ''
  const assessmentId = payload.params.assessment || ''

  const url = useCsRoutes('assessments.show', {
    '[discipline_id]': disciplineId,
    '[assessment_id]': assessmentId,
  })

  options?.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const assessmentInfo = data.data

    commonStore.setLoading(false)
    options?.onSuccess?.(assessmentInfo)

    return assessmentInfo
  } catch (err) {
    console.error(err)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
